import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadSessionManagement, exportSessionManagement } from './actions';
import List from './List';
import Filter from './Filter';
import { loadUnpagedGrades } from '../../grades/actions';
import { saveAs } from 'file-saver';

class SessionManagementReport extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadGrades();

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });

		if (isExport)
			this.exportData(filter);
	}

	exportData(filter) {
		this.props.exportReport(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { grades } = this.props;
		const { filter } = this.props.pagination;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} grades={grades} initialValues={filter} loading={this.props.pagination.loading || this.props.export.loading} />
				<List data={this.props.data} onFetchData={this.handleListEvent} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		exports,
		entities: { sessionManagement, grades }
	} = state;

	const sessionManagementPagination = pagination.sessionManagement.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const sessionManagementExport = exports.sessionManagement.all || {};

	return {
		data: sessionManagementPagination.ids.map(id => sessionManagement[id]),
		pagination: sessionManagementPagination,
		export: sessionManagementExport,
		grades: grades
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadSessionManagement,
	loadUnpagedGrades,
	exportReport: exportSessionManagement,
	resetFilter: () => reset('sessionManagementFilter')
})(SessionManagementReport);